import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertDialogService } from "./../../components/_alert-dialog/alert-dialog.service";
import { AdministreDialogService } from "./administre-dialog.service";
import { Administre } from "../../interfaces/Administre";

@Component({
  selector: "administre-dialog",
  templateUrl: "administre-dialog.html",
  standalone: false,
})
export class AdministreDialogComponent implements OnInit {
  administre: Administre;
  isLoading: boolean = false;

  constructor(
    public _dr: MatDialogRef<AdministreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public administre_ID: number,
    public _s: AdministreDialogService,
    private _alert: AlertDialogService
  ) {}

  ngOnInit(): void {
    this.getAdministre();
  }

  getAdministre(): void {
    this.isLoading = true;
    this._s.get(this.administre_ID, (administre: Administre) => {
      this.administre = administre;
      this.isLoading = false;
    });
  }

  postAdministre(): void {
    this.isLoading = true;
    this._s.post(this.administre, (administre: Administre) => {
      this.administre = administre;
      this.isLoading = false;
    });
  }

  deleteAdministre(): void {
    this._alert.openConfirm(
      "Voulez-vous vraiment supprimer ce compte administré ?",
      () => {
        this.isLoading = true;
        this._s.delete(this.administre.administre_ID, () => {
          this.isLoading = false;
          this._dr.close(true);
        });
      }
    );
  }

  close(): void {
    this._dr.close(false);
  }
}
